// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1GiIw","captions":"style_captions__VTAD8"};